import { z } from "zod";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
/**
 * El yıkama sıra ekranı (Prompt 18, ADR 0018 §14): istasyonun WAITING / IN_PROGRESS / READY iş emirleri. Müşterinin de
 * gördüğü ekrandır → plaka MASKELİDİR (`34****23`), ad / telefon / not YOKTUR. Canlı güncelleme istasyon odasındaki
 * `wash.work_order.status_changed` olayıyla (istemci olayda yeniden çeker).
 */
export const washQueueQuerySchema = z.object({ stationId: uuidSchema });
export const washQueueItemSchema = z.object({
    workOrderId: uuidSchema,
    orderNo: z.string(),
    status: z.enum(["WAITING", "IN_PROGRESS", "READY"]),
    since: timestampSchema.describe("Bu duruma geçiş anı"),
    maskedPlate: z.string().nullable(),
    unitName: z.string().nullable(),
    programNames: z.array(z.string()),
    estimatedReadyAt: timestampSchema.nullable(),
});
export const washQueueSchema = z.object({
    stationId: uuidSchema,
    generatedAt: timestampSchema,
    items: z.array(washQueueItemSchema),
});
//# sourceMappingURL=queue.js.map